import PropTypes from 'prop-types';

function IFPantryActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11301)">
                <path
                    d="M7.81525 13.907C7.22206 13.6864 6.59097 13.5858 5.95861 13.6111C5.32624 13.6364 4.7052 13.7871 4.13153 14.0543C3.30319 14.4844 2.05271 15.3685 2.3036 15.7548C2.55449 16.1411 3.85674 16.3243 3.42266 17.3199C2.98858 18.3155 3.42266 18.6978 4.1156 18.9129C4.40223 18.9917 4.64796 19.1769 4.80265 19.4308C4.95733 19.6847 5.00929 19.988 4.94792 20.2788C4.78464 20.7687 5.05544 22.0351 5.95547 22.0948C6.85549 22.1546 7.48869 23.186 7.52453 23.6878C7.56038 24.1896 7.70374 24.7511 8.37677 24.8467C9.04979 24.9422 11.5826 25.0139 11.5985 20.6293C11.5985 17.0451 14.7845 18.3474 15.6287 18.8053C16.473 19.2633 19.4558 19.5142 20.2961 17.8376C21.1364 16.161 19.1372 16.5752 18.9779 16.0177C18.8186 15.4601 19.8262 14.9583 19.5195 14.1897C19.2129 13.4211 18.3248 13.9428 18.0978 12.9671C17.8708 11.9915 18.8226 10.7848 17.823 10.5777C16.8234 10.3706 16.4411 10.6773 16.0986 10.1795C15.7562 9.68166 15.9394 8.89315 15.3022 8.41128C14.665 7.92941 12.0724 9.12413 11.6543 11.2786C11.2361 13.4331 11.7339 14.4207 10.7144 14.8628C9.69494 15.3048 9.34847 14.4207 7.81525 13.907Z"
                    fill="#F7D46D"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M8.16571 17.4035C8.16571 17.4035 8.43651 16.149 11.8096 16.5871C15.3579 17.045 15.565 15.8384 15.565 15.8384"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.3226 13.9066C14.3226 13.9066 13.1278 13.4725 11.7061 16.5629C10.2167 19.8205 9.08569 19.3506 9.08569 19.3506"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M26.8949 9.79682L16.5406 1.99928C16.2382 1.67777 15.8642 1.432 15.4491 1.28187C15.034 1.13173 14.5894 1.08145 14.1512 1.1351C12.4826 1.38599 11.3834 3.28161 11.6941 5.36839C11.7665 5.955 11.9631 6.51945 12.2707 7.02415C12.5784 7.52886 12.99 7.96224 13.4782 8.29546V8.29546L24.0395 16.2603C24.3358 16.5493 24.6933 16.768 25.0855 16.9004C25.4777 17.0327 25.8946 17.0753 26.3055 17.0249C27.9741 16.774 29.0932 14.8784 28.7626 12.7916C28.6936 12.1849 28.4901 11.6013 28.167 11.0833C27.8439 10.5652 27.4093 10.1257 26.8949 9.79682V9.79682Z"
                    fill="#F7D46D"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M15.2916 8.69569C16.9601 8.44692 18.0603 6.55231 17.7489 4.46395C17.4376 2.37559 15.8326 0.884301 14.1641 1.13307C12.4955 1.38183 11.3954 3.27645 11.7067 5.36481C12.0181 7.45317 13.6231 8.94445 15.2916 8.69569Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.8071 4.85498L28.7786 12.78"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.584 6.53564L28.7547 14.3173"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.9669 7.69824L28.2291 15.6869"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1186 8.66602L27.126 16.5631"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M24.852 18.7812C25.4374 19.1795 27.114 21.1428 27.2893 23.1261C27.4645 25.1093 26.9986 27.9049 24.9556 28.789C22.9126 29.6731 20.0094 30.7006 16.9589 27.7377C16.2187 27.0611 15.5416 26.3187 14.9359 25.5195C15.3341 25.5195 18.9183 22.8274 18.9183 22.8274C18.9183 22.8274 20.5829 24.8186 21.7059 24.5279C22.829 24.2371 22.144 22.4769 21.0966 21.2503C21.9489 20.2786 24.852 18.7812 24.852 18.7812Z"
                    fill="#F7D46D"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23.6396 21.173C24.7196 20.5495 25.3232 19.5731 24.9878 18.9921C24.6524 18.4112 23.505 18.4457 22.425 19.0692C21.345 19.6928 20.7414 20.6692 21.0768 21.2501C21.4122 21.8311 22.5596 21.7966 23.6396 21.173Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.5568 25.2345C18.6901 24.5801 19.337 23.5788 19.0016 22.9978C18.6661 22.4169 17.4755 22.4763 16.3422 23.1307C15.2088 23.785 14.562 24.7864 14.8974 25.3673C15.2328 25.9483 16.4235 25.8888 17.5568 25.2345Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11301">
                    <rect width="30" height="30" fill="white" transform="translate(0.545898 0.194336)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFPantryActive;

IFPantryActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFPantryActive.defaultProps = {
    className: null,
};
